// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"26":"0e86c79f3ab09014","70":"0b8e6b36720de922","83":"39d06a71754409fd","152":"bdcaf028815ec65a"}[chunkId] + ".js";
};